<template>
    <div class="viewBOLET">
        <div class="modal-conteudo m-2">
            <div id="divImprimir">
                <!--<h3 class="bold txtApp" v-html="dados.nmTitulo"></h3>-->
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Acórdão:</h6>
                        <template v-if="dados.dsTextoAcordao == null || dados.dsTextoAcordao == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.dsTextoAcordao"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Indexação:</h6>
                        <template v-if="dados.dsIndexacao == null || dados.dsIndexacao == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.dsIndexacao"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Enunciado:</h6>
                        <template v-if="dados.dsEnunciado == null || dados.dsEnunciado == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.dsEnunciado"></span>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer pb-0 mt-4 d-flex justify-content-end">
            <a :href="dados.urlDocumentoPdf" class="btn-default bg-solid-primary txt-size-14" >
                <i class="fas fa-file-pdf"></i> Baixar PDF
            </a>
            <a :href="dados.urlDocumento" class="btn-default bg-solid-primary txt-size-14" >
                <i class="fas fa-file-word"></i> Baixar Word
            </a>

            <button class="btn-default bg-solid-primary txt-size-14" @click="imprimir">
                <i class="fas fa-print"></i> Imprimir
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'viewBOLET',
        components: {  },
        data: function () {
            return {
                tpConteudo: 'Pesquisa',
                cdConteudo: 'BOLET',
            }
        },
        props: {
            dados: Object,
        },
        methods: {
            imprimir() {
                var conteudo = document.getElementById('divImprimir').innerHTML,
                    tela_impressao = window.open('about:blank');

                tela_impressao.document.write(conteudo);
                tela_impressao.window.print();
                tela_impressao.window.close();
            },
        },
        mounted: function () {
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
   
</style>

